import { Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IOfferGalleryProps {
  images: string[];
  onScroll(): void;
  onClick(): void;
}

export const OfferGallery: React.VFC<IOfferGalleryProps> = ({ images, onScroll, onClick }) => {
  return (
    <div className={styles['scroll']} onScroll={onScroll}>
      {images.map(url => (
        <div key={url} className={styles['image']}>
          <div className={styles['image-inner']}>
            <Image src={url} alt="" objectFit={'cover'} preloader onClick={onClick} />
          </div>
        </div>
      ))}
    </div>
  );
};
